// tslint:disable:max-line-length

import React from 'react';

export const ActionReset = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 16 16" {...props}>
      <path d="M12,14c2.2,0,4-1.8,4-4c0-0.1,0-1.1,0-1.2C15.9,6.7,14.1,5,12,5H5V2L0,6l5,4V7h7c1.1,0,1.9,0.8,2,1.9V10c0,1.1-0.9,2-2,2H9 v2H12z" />
    </svg>
  );
};
